import styled from '@emotion/styled'
import { bool } from 'yup'

interface SectionRootProps {
    fullWidth?: boolean
}

export const SectionRoot = styled.div<SectionRootProps>(({ theme }) => {
    return {
        boxShadow: 'rgb(0 0 0 / 1%) 0px 20px 25px, rgb(0 0 0 / 1%) 0px 10px 10px',
        borderRadius: theme.spacing(3),
        padding: theme.spacing(5),
        flex: '2 1 0',
        marginBottom: theme.spacing(4),
        background: theme.color.neutral.salt[100],

        [theme.breakpoints.down(theme.breakpoints.md)]: {
            padding: theme.spacing(3),
        },
    }
})

export const SectionTitle = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.default,
        color: props.theme.sections.serviceDetail.foreground,
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '36px',
        lineHeight: '47px',
        marginBottom: 0,
        marginTop: 0,
    }
})

export const SectionHint = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.default,
        color: props.theme.sections.serviceDetail.foreground,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '28px',
        lineHeight: '36px',
        marginBottom: props.theme.spacing(2),
        opacity: 0.6,
    }
})

export const SectionDescription = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.default,
        color: props.theme.sections.serviceDetail.foreground,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '18px',
        lineHeight: '23px',
        marginBottom: props.theme.spacing(3),
    }
})

export const ServiceStepCase = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.default,
        color: props.theme.sections.serviceDetail.foreground,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '28px',
        lineHeight: '36px',
        marginBottom: props.theme.spacing(2),

        opacity: 0.6,
    }
})

export const ServiceStepCategory = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.default,
        color: props.theme.sections.serviceDetail.foreground,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '27px',
        marginBottom: props.theme.spacing(2),
        marginTop: props.theme.spacing(2),
    }
})

export const ServiceStepWrapper = styled.article((props) => {
    return {
        paddingBottom: props.theme.spacing(2),
    }
})

export const ServiceStepTitle = styled.h3(({ theme }) => {
    return {
        fontFamily: theme.fonts.default,
        color: theme.color.brand.secondary[900],
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: theme.spacing(2.3),
        lineHeight: '26px',
        marginBottom: theme.spacing(2),
    }
})

export const ServiceStepDescription = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.body,
        color: props.theme.color.neutral.slate[700],
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '1.5',
        //letterSpacing: '0.6',
        marginBottom: props.theme.spacing(2),
    }
})

export const ServiceDescription = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.body,
        color: props.theme.color.brand.secondary[900],
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '1.5',
        marginBottom: props.theme.spacing(5),
        paddingBottom: props.theme.spacing(5),
        borderBottom: `1px solid ${props.theme.color.neutral.slate[100]}`,
    }
})

export const ServiceHierarchy = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.default,
        color: props.theme.sections.serviceDetail.foreground,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '18px',
        lineHeight: '23px',
        marginBottom: props.theme.spacing(3),
    }
})
